import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { DataService } from '../../services/data/data.service';
import { ConfigService } from '../../services/config/config.service';
import { CommsService } from '../../services/comms/comms.service';
import { HelpService } from '../../services/help/help.service';
import { TimesheetService } from '../../services/timesheet/timesheet.service';
import { DisplayService } from '../../services/display/display.service';
import { SmartContractService } from '../../services/smart-contract/smart-contract.service';
import { NoteService } from '../../services/note/note.service';
import { ContractorService } from '../../services/contractor/contractor.service';
import { NotificationService } from '../../services/notification/notification.service';
import _ from 'lodash';
import { ActivatedRoute } from '@angular/router';
import { TabService } from '../../services/tab/tab.service';

@Component({
	selector: 'pcm-page-timesheets',
	templateUrl: './page-timesheets.component.html',
	styleUrls: ['./page-timesheets.component.scss']
})
export class PageTimesheetsComponent implements OnInit, OnDestroy {

	@ViewChild('modalForm') modalForm;
	@ViewChild('migrateModalForm') migrateModalForm;

	title = 'Timesheets';
	dataObj = this.configService.timesheetDataObj;
	actions = [];
	exportAction = [];
	allcolumns = [];
	showExportModal = false;

	jrSteps = [];
	jrStepIDs = [];

	initTab = '';

	userSettingsListener;
	isFirstTableLoad = true;
	tooltips: any = {};

	defaultSort = [
		{
			prop: this.configService.timesheetEndProp,
			dir: 'desc'
		}
	];

	constructor(
		public configService: ConfigService,
		private commsService: CommsService,
		private dataService: DataService,
		public helpService: HelpService,
		public timesheetService: TimesheetService,
		private displayService: DisplayService,
		private smartContractService: SmartContractService,
		private noteService: NoteService,
		public contractorService: ContractorService,
		private notificationService: NotificationService,
		private route: ActivatedRoute,
		private tabService: TabService
	) {
		this.helpService.timesheets.forEach(step => {
			this.jrSteps.push(step);
			this.jrStepIDs.push(step.id);
		});

		// Required for displayCheck function to access notification service
		this.displayCheck = this.displayCheck.bind(this);
	}

	ngOnInit() {
		this.displayService.startLoading();

		this.timesheetService.showErrorTimesheets = false;
		this.timesheetService.showSuccessTimesheets = false;

		this.actions = this.configService.getActions(this.dataObj);
		this.exportAction = [];
		this.exportAction.push(this.configService.getExportAction());
		if (this.actions.length === 0) {
			this.actions.push(this.configService.getExportAction());
		}

		this.tooltips = this.helpService.timesheet_tooltips;

		this.route.params.subscribe(async params => {
			this.initTab = params['initTab'];
			if (!this.initTab) {
				this.initTab = 'pending';
			}
			const activeTab = this.timesheetService.tabsData.listTabs.find(tab => {
				return tab.prop === this.initTab;
			});

			if (activeTab['pageSize']) {
				this.timesheetService.rowsPerPage = activeTab['pageSize'];
			} else {
				this.timesheetService.rowsPerPage = this.configService.pageSize;
			}

			// need clean up sort
			if (activeTab['sortParam']) {
				activeTab['sortParam'] = '';
				activeTab['sortDir'] = '';
			}

			// if countries haven't been retrieved, OR if multiple persona, retrieve countries
			// (switching personas cause problems with caching country list, so just always retrieve it for those users)
			if (!this.timesheetService.userManagedCountries || this.timesheetService.isMultiplePersona()) {
				await this.retrieveUserManagedCountries();
			}

			// end the display service loading; the table has its own loading indicator
			this.displayService.endLoading();

			if (this.timesheetService.userManagedCountrySelection) {
				this.loadTable();
			}
		});

		this.userSettingsListener = this.dataService.userSettingsListener().subscribe(async () => {
			console.log('USER SETTINGS EVENT');
			// if user settings changes (like persona change), retrieve country list again.
			// this may also trigger reloading the table, if the country can be automatically chosen
			await this.retrieveUserManagedCountries();
			if (this.timesheetService.userManagedCountrySelection) {
				this.loadTable();
			}
		});
	}

	ngOnDestroy() {
		this.userSettingsListener.unsubscribe();
	}

	allowAction = () => {
		return this.dataService.selectedTableRows[0] !== undefined;
	}

	takeAction(event) {
		console.log('TAKE ACTION', event);
		if (event.action.prop === 'exporttocsv') {
			this.showExportModal = true;
		} else if (event.action.prop === 'migratetimesheet') {
			this.migrateModalForm.showModal(event.action, this.configService.timesheetSCDataObj, this.dataService.selectedTableRows);
		} else {
			this.modalForm.showModal(event.action, this.configService.timesheetSCDataObj, this.dataService.selectedTableRows);
		}
	}

	modalSubmit(event) {
		console.log('MODAL SUBMIT', event);
		this.smartContractService.submitSmartContract(event.data, event.prop, this);
		const self = this;
		const delay = setTimeout(function () {
			self.modalForm.formCancel();
		}, 1000);
	}

	migrateModalSubmit(event) {
		console.log('MIGRATE MODAL SUBMIT', event);
		this.smartContractService.submitSmartContract(event.data, event.prop, this);
		const self = this;
		const delay = setTimeout(function () {
			self.migrateModalForm.formCancel();
		}, 1000);
	}

	handlePartialSuccess(res) {
		this.timesheetService.handlePartialSuccess({ error: res });

		const self = this;
		const delay = setTimeout(function () {
			const tabs = self.timesheetService.tabsData.listTabs;
			self.timesheetService.selectActiveTab(tabs, self.timesheetService.getActiveTab(tabs)['prop']);
		}, 2000);
	}

	errorCall(res) {
		this.noteService.displayError('Failed to process the selected timesheets');
		console.log('BULK TIMESHEETS ERROR');
		this.handlePartialSuccess(res);
	}

	successCall() {
		console.log('PAGE TIMESHEETS SUCCESS CALL');
		this.dataService.clearSelectedTableRows();
		const self = this;
		const delay = setTimeout(function () {
			const tabs = self.timesheetService.tabsData.listTabs;
			self.timesheetService.selectActiveTab(tabs, self.timesheetService.getActiveTab(tabs)['prop']);
			self.notificationService.loadQueueItems();
		}, 2000);
	}

	partialCall(res) {
		this.noteService.displayError('Failed to process some or all the selected timesheets');
		console.log('BULK TIMESHEETS PARTIAL');
		this.handlePartialSuccess(res);
		const self = this;
	}

	closeExportModal() {
		this.showExportModal = false;
	}

	exportToCSV(event) {
		this.commsService.exportToCSV(event.data, this.allcolumns, this.dataService.selectedTableRows);
		const self = this;
		const delay = setTimeout(function () {
			self.closeExportModal();
		}, 1000);
	}

	tableClick(event) {
		if (!this.displayCheck(event.row)) {
			this.noteService.displayInfo('This timesheet is in the queue pending processing. Please check back once the queue has completed. Queue status can be monitored using the clock icon at the top of the page.');
		} else {
			this.timesheetService.tableClick(event);
		}
	}

	tableSelect(event) {
		console.log('TIMESHEET TABLE SELECT: ', event);
		// this.dataService.selectedTableRows = event.selected;
		this.dataService.selectedTableRows = event.selected.filter(this.displayCheck);
	}

	/**
	 * @param {any} row - A timesheet table row
	 * @returns {boolean} Returns false if the purchase order is in the queue.
	 * This function is used by this.tableSelect and this.tableClick
	 */
	displayCheck(row: any): boolean {
		return !this.notificationService.isInQueue(row.id);
	}

	/**
	 * action for when the user selects a country from the list, if any
	 */
	timesheetTableCountrySelectionAction(event) {
		this.timesheetService.selectUserManagedCountry(event.action);
		this.loadTable();
	}

	/**
	 * Loads data for the table. First makes sure the table config is set based on the selected country.
	 */
	loadTable() {
		this.setTableConfig();
		const loadTab = this.isFirstTableLoad ? this.initTab : this.timesheetService.tabsData.listTabs.find(x => x.active)?.prop;
		this.tabService.loadTab(this.timesheetService.tabsData.listTabs, this.timesheetService, loadTab);
		this.isFirstTableLoad = false;
	}

	/**
	 * Sets the column config setting based on the selected country
	 */
	setTableConfig() {
		this.allcolumns = this.configService.getTableFields(this.dataObj, false, this.timesheetService.userManagedCountrySelection?.prop[0]);
	}

	/**
	 * check if the UI should hide the table and show the message instead
	 */
	hideTableForCountrySelect() {
		// if there is more than one country to choose from and have not made a selection, hide the table
		return this.timesheetService.userManagedCountries?.length > 1 && !this.timesheetService.userManagedCountrySelection;
	}

	/**
	 * check if UI needs to hide the table while country list is being retrieved
	 */
	hideTableWhileLoadingCountries() {
		return this.timesheetService.userManagedCountries === undefined || this.hideTableForCountrySelect();
	}

	/**
	 * check if UI should display the country selector on the page
	 */
	showCountrySelector() {
		return this.timesheetService.userManagedCountries?.length > 1;
	}

	async retrieveUserManagedCountries() {
		this.displayService.startLoading();
		await this.timesheetService.retrieveUserManagedCountries();
		this.displayService.endLoading();

		// if only one country is retrieved, then set it as the selected country automatically
		if (!this.timesheetService.userManagedCountrySelection && this.timesheetService.userManagedCountries.length === 1) {
			this.timesheetService.selectUserManagedCountry(this.timesheetService.userManagedCountries[0]);
		// else if no country is returned, default to using the US code. the table should be empty anyway
		} else if (!this.timesheetService.userManagedCountrySelection && this.timesheetService.userManagedCountries.length === 0) {
			this.timesheetService.selectUserManagedCountry({ prop: this.configService.countryCodes.US });
		}
	}
}
